<template>
    <v-container fluid row grid-list-md>
        <v-layout row wrap>
            <v-flex sm12 md4>
                <v-card class="mb-2">
                    <v-card-text>
                        <v-list three-line>
                            <v-list-tile>
                                <v-list-tile-action>
                                    <v-icon>perm_identity</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                    <v-list-tile-title class="text--secondary">No. de Control</v-list-tile-title>
                                    <v-list-tile-sub-title class="text--primary">{{alumno.noDeControl}}</v-list-tile-sub-title>
                                </v-list-tile-content>
                            </v-list-tile>
                            <v-divider inset></v-divider>
                            <v-list-tile>
                                <v-list-tile-action>
                                    <v-icon>account_box</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                    <v-list-tile-title class="text--secondary">Nombre Completo</v-list-tile-title>
                                    <v-list-tile-sub-title class="text--primary">{{alumno.nombreCompleto}}</v-list-tile-sub-title>
                                </v-list-tile-content>
                            </v-list-tile>
                            <v-divider inset></v-divider>
                            <v-list-tile>
                                <v-list-tile-action>
                                    <v-icon>class</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                    <v-list-tile-title class="text--secondary">Carrera</v-list-tile-title>
                                    <v-list-tile-sub-title class="text--primary">{{alumno.carrera}}</v-list-tile-sub-title cla>
                                </v-list-tile-content>
                            </v-list-tile>
                            <v-divider inset></v-divider>
                            <v-list-tile>
                                <v-list-tile-action><v-icon></v-icon></v-list-tile-action>
                                <v-list-tile-content>
                                    <v-list-tile-title class="text--secondary">Semestre Actual</v-list-tile-title>
                                    <v-list-tile-sub-title class="text--primary">{{alumno.semestre}}</v-list-tile-sub-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                    </v-card-text>
                </v-card>

                <v-alert
                  :value="true"
                  color="warning"
                  icon="priority_high"
                  outline
                >
                  Recuerda que la Fotografía debe de ser de frente, sin anteojos, cabello recogido y con fondo blanco.
                  <a href="https://s3.ittg.edu.mx/estudiantes/ejemplo.jpeg" target="_blank">Muestra</a>
                </v-alert>

                <imagen-usuario></imagen-usuario>
                <firma-usuario></firma-usuario>
            </v-flex>
            <v-flex sm12 md8>
                <personal-data></personal-data>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
  import PersonalData from '@/components/forms/PersonalData'
  import ImagenUsuario from '@/components/forms/ImagenUsuario'
  import FirmaUsuario from '@/components/forms/FirmaUsuario'
  import { mapState } from 'vuex'

  export default {
    name: 'PersonalPage',
    components: {ImagenUsuario, PersonalData, FirmaUsuario},
    computed: {
      ...mapState({
        alumno: state => state.user.profile
      })
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/information/PersonalPage.vue